'use strict';

// State
const state = {
  transitionState: `hidden`,
  isTransitioning: false,
};

// Getters
const getters = {
  headerTransitionState: state => state.transitionState,
};

// Mutations
const mutations = {
  CHANGE_STATE (state, transitionState) {
    state.transitionState = transitionState;
  },
  SET_TRANSITIONING (state, boolean) {
    state.isTransitioning = boolean;
  },
};

// Actions
const actions = {
  toggleHeader({ commit, state }) {
    if(state.isTransitioning) return false;
    commit(`SET_TRANSITIONING`, true);
    let stepOne = `out`;
    let stepTwo = `hidden`;

    if(state.transitionState === `hidden`) {
      stepOne = `in`;
      stepTwo = `show`;
    }
    commit(`CHANGE_STATE`, stepOne);

    setTimeout(() => {
      commit(`CHANGE_STATE`, stepTwo);
      commit(`SET_TRANSITIONING`, false);
    }, 200);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/header.js